// Forms are created using React-Hook-Form (https://react-hook-form.com/)
/* eslint-disable camelcase */
import React, { useEffect } from 'react';

import Button from '../../Button';
import LazyImage from '../../LazyImage';

import { HeroFormContainer, styledButtonModernForm } from './SignupFormModernStyles';

const SignupFormModern = () => {
  const onFormSubmit = event => {
    event.preventDefault();

    window.optimizely.push({
      type: 'event',
      eventName: 'clicked_signup_button',
      tags: {
        action: 'click',
        category: 'form',
        name: 'signup',
      },
    });

    window.analytics.track('Web Interaction', {
      action: 'click',
      category: 'form',
      name: 'signup',
    });

    if (document.getElementById('heroHomeForm')) {
      setTimeout(function() {
        document.getElementById('heroHomeForm').submit();
      }, 500);
    }
  };

  const onButtonClick = event => {
    const clickId = event.currentTarget.id.replace('_button', '');
    const dataHref = event.currentTarget.dataset.href;
    window.optimizely.push({
      type: 'event',
      eventName: 'clicked_signup_button',
      tags: {
        action: 'click',
        category: clickId,
        name: 'signup',
      },
    });

    window.analytics.track('Web Interaction', {
      action: 'click',
      category: clickId,
      name: 'signup',
    });

    if (dataHref) {
      setTimeout(function() {
        window.location.href = dataHref;
      }, 500);
    }
  };

  useEffect(() => {
    window.analytics.page('Home', {
      form_loaded: true,
    });
  }, []);

  return (
    <HeroFormContainer>
      <form
        className="form-align-left"
        action="https://cloud.digitalocean.com/registrations"
        id="heroHomeForm"
        method="post"
        onSubmit={onFormSubmit}
      >
        <span className="formWrapperParent">
          <div className="inputFormWrapper">
            <input
              aria-label="signup button"
              type="text"
              minLength="2"
              name="user[name]"
              placeholder="First Name"
              required
            />
            <input aria-label="email" type="email" name="user[email]" placeholder="Email Address" required />
            <input
              aria-label="password"
              type="password"
              minLength="8"
              name="user[password]"
              placeholder="Password"
              required
            />
          </div>
        </span>
        <div className="buttonWrapper">
          <span className="signupBtnWrapper">
            <Button className="is-primary is-full-width" type="submit" id="form_button_test">
              Deploy in seconds
            </Button>
          </span>
        </div>
      </form>
      <span className="iconPositionWrapper">
        <span className="iconWrapperMaster">
          <span className="iconWrapper">
            <Button
              onClick={onButtonClick}
              data-href="https://cloud.digitalocean.com/registrations/google"
              id="google_button"
              aria-label="google signup"
              css={styledButtonModernForm}
            >
              <LazyImage
                src="https://www-static.cdn.prismic.io/www-static/7b66f955-63dd-41f5-a403-e6727b24d4ea_google-logo.svg"
                alt="google_icon"
              />
            </Button>
          </span>
          <span className="iconWrapper">
            <Button
              onClick={onButtonClick}
              data-href="https://cloud.digitalocean.com/registrations/github"
              id="github_button"
              aria-label="github signup"
              css={styledButtonModernForm}
            >
              <LazyImage
                src="https://www-static.cdn.prismic.io/www-static/0a3e37e0-1706-41d5-98d1-854585205a5e_github-logo.svg"
                alt="github_icon"
              />
            </Button>
          </span>
        </span>
      </span>
      <div className="termsLink">
        By signing up you agree to the <a href="/legal/terms-of-service-agreement/">terms of service</a>.
      </div>
    </HeroFormContainer>
  );
};

export default SignupFormModern;
